export interface ProjectLocalizations {
    backToList?: string | null;
    aboutRegistry?: string | null;
    aboutText?: string | null;
    aboutLogo?: string | null;
    subjectAlreadyExistsText?: string | null;
    subjectAlreadyExistsOpenButton?: string | null;
    subjectAlreadyExistsCancelButton?: string | null;
}
